<template>
  <Modal :id="id" :hide-footer="true">
    <div class="modal-header border-0 p-0" slot="header">
      <a
        class="corner-icon icon icon-remove text-right text-dark"
        @click.prevent="close()"
        data-dismiss="modal"
        aria-label="Close"
      ></a>
    </div>
    <div class="video-modal-body" slot="body">
      <iframe
        v-if="!!video && !!video.video_url"
        :src="video.video_url"
        frameborder="no"
        allowfullscreen
        webkitallowfullscreen
        mozallowfullscreen
        style="height: 280px; width: 498px; float: left"
      ></iframe>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "../../../../mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "video-modal",
      video: null,
    };
  },
  mounted() {
    this.video = this.options.video || null;
  },
};
</script>